import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-warning-diamond fs-25" }, null, -1 /* HOISTED */)
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "d-inline-flex text-decoration-none lh-1 fw-medium gap-1 align-items-center ms-auto mt-10"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-caret-right text-black fs-16 lh-1" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" DELETE PROCESS "),
    _createElementVNode("div", {
      class: _normalizeClass(["alert alert-warning d-flex align-items-start fs-md-15 fs-lg-16 gap-3 mb-30 show", { 'cursor-pointer': _ctx.show_link }]),
      role: "alert",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.redirect && _ctx.redirect(...args)))
    }, [
      _hoisted_1,
      _createElementVNode("div", null, [
        _createElementVNode("p", {
          class: "mb-0",
          innerHTML: _ctx.$t('feature.auth.$delete_account.process_pending_warning', {
        patient_full_name: `${_ctx.patient.firstname ?? ''} ${_ctx.patient.lastname ?? ''}`,
      })
        
        }, null, 8 /* PROPS */, _hoisted_2),
        (_ctx.show_link)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.$t("cta.view")) + " ", 1 /* TEXT */),
              _hoisted_4
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ], 2 /* CLASS */)
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}